module.exports = __webpack_public_path__ + "media/images/skdo-logo-a9fbb66e8c33318bd3fbac94868db0ad.svg";